export interface CustomerLight {
  id: number,
  system: CustomerSystem,
}

export enum CustomerSystem {
  CIS = 'cis',
  DESK = 'desk',
  MAGIC = 'magic',
  PHPNET = 'phpnet',
  NUXIT = 'nuxit',
  ICOW = 'icow'
}

export interface Customer extends CustomerLight{
  name: string
}